import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as serviceWorker from './serviceWorker';
import {OpenCvProvider} from 'opencv-react';

ReactDOM.render(
  // Self-hosted: docs.opencv.org now blocks cross-origin loads (CORP: same-origin)
  <OpenCvProvider openCvPath={`${process.env.PUBLIC_URL}/opencv/opencv.js`}>
    <App />
  </OpenCvProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
